export const getInfo = (state) => state.users.info;
